import { BubbleMenu as BaseBubbleMenu, Editor } from '@tiptap/react';
import React, { useCallback } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Divider,
} from '@material-ui/core';
import {
  ArrowUpward,
  ArrowDownward,
  Delete,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import { isRowGripSelected } from './utils';

const TableRowMenu = React.memo(({ editor, appendTo }) => {
  const shouldShow = useCallback(
    ({ view, state, from }) => {
      if (!state || !from) return false;
      return isRowGripSelected({
        editor, view, state, from,
      });
    },
    [editor],
  );

  const onAddRowBefore = useCallback(() => {
    editor.chain().focus().addRowBefore().run();
  }, [editor]);

  const onAddRowAfter = useCallback(() => {
    editor.chain().focus().addRowAfter().run();
  }, [editor]);

  const onDeleteRow = useCallback(() => {
    editor.chain().focus().deleteRow().run();
  }, [editor]);

  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey="tableRowMenu"
      updateDelay={0}
      tippyOptions={{
        appendTo: () => appendTo?.current,
        placement: 'auto-end',
        offset: [0, 15],
        popperOptions: {
          modifiers: [{ name: 'flip', enabled: false }],
        },
      }}
      shouldShow={shouldShow}
    >
      <Paper elevation={3} className="py-2 px-1 w-52">
        <List component="nav" dense>
          <ListItem button onClick={onAddRowBefore}>
            <ListItemIcon>
              <ArrowUpward fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Add row before" primaryTypographyProps={{ className: 'text-sm' }} />
          </ListItem>

          <ListItem button onClick={onAddRowAfter}>
            <ListItemIcon>
              <ArrowDownward fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Add row after" primaryTypographyProps={{ className: 'text-sm' }} />
          </ListItem>

          <Divider className="my-1" />

          <ListItem button onClick={onDeleteRow}>
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Delete row" primaryTypographyProps={{ className: 'text-sm text-red-600' }} />
          </ListItem>
        </List>
      </Paper>
    </BaseBubbleMenu>
  );
});
const DOMElement = typeof Element !== 'undefined' ? Element : () => {};
TableRowMenu.displayName = 'TableRowMenu';
TableRowMenu.propTypes = {
  editor: PropTypes.instanceOf(Editor).isRequired,
  appendTo: PropTypes.shape({ current: PropTypes.instanceOf(DOMElement) }).isRequired,
};
export default TableRowMenu;
